

















import { Component, Vue } from 'vue-property-decorator';
import { Route } from 'vue-router';
import { $config, $module } from '../services';

import ModuleStatus from '../components/ModuleStatus.vue';


@Component({
  components: { ModuleStatus },
})
export default class Home extends Vue {

  constructor(){
    super();
  }

  get modules() {
    return $module.store.modules;    
  }

  get config(){
    return $config.store.config;
  }

  beforeRouteEnter(to: Route, from: Route, next: any) {
    const load = [$config.get(),$module.getAll()]
    Promise.all(load).then(next);
  }

}
